export const SCORE_VALUE_CARD: number = 15;
export const SCORE_ANCHOR_CARD: number = 0;
export const SCORE_WATER_CARD: number = 0;
export const SCORE_BOOM_CARD: number = 100;
export const SCORE_BOOM_TARGET_CARD: number = 100;
export const SCORE_ALGAE_CARD: number = 0;
export const SCORE_CRAB_CARD: number = 0;
export const SCORE_KEY_CARD: number = 0;
export const SCORE_LOCK_CARD: number = 50;
export const SCORE_PLUS_THREE_CARD: number = 0;
export const SCORE_PLUS_THREE_NEW_CARD: number = 0;
export const SCORE_TORNADO_CARD: number = 0;
export const SCORE_TORNADO_TARGET_CARD: number = 0;
export const SCORE_BOMB_CARD: number = 150;
export const SCORE_FOG_CARD: number = 0;
export const SCORE_ZAP_CARD: number = 100;
export const SCORE_ZAP_TARGET_CARD: number = 100;
export const SCORE_ICE_CARD: number = 0;
export const SCORE_JOKER_BOOSTER: number = SCORE_VALUE_CARD;
export const SCORE_BULLSEYE_BOOSTER: number = SCORE_VALUE_CARD;
export const SCORE_TNT_BOOSTER: number = SCORE_VALUE_CARD;
